<template>
  <div class="verify-container">
    <Loading v-if="isLoading" />
    <div v-else class="verify-content">
      <div class="brand-section">
        <div class="logo-container">
          <img src="@/assets/img/logo/logo.jpeg"  alt="App Follower Logo" class="app-logo" />
        </div>
        <h1 class="app-name">App Follower</h1>
        <p class="tagline">Verify your email to get started</p>
      </div>
      
      <div class="verification-card">
        <div class="card-content">
          <div class="icon-container">
            <svg class="email-icon" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
          </div>
          <h2 class="verify-title">Email Verification Required</h2>
          <p class="verify-description">
            Please verify your email address to access all features of App Follower.
            Click the button below to receive a verification link.
          </p>
          <button @click="sendVerifyLink" class="verify-button">
            <span>{{ $t('sendVerifyLink') }}</span>
            <svg class="button-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
	<NotificationComponent
		v-if="notification.show"
		:key="notification.key"
		:type="notification.type"
		:title="notification.title"
		:message="notification.message"
		@closed="!notification.show"
	/>
</template>

<script>
import Loading from "@/components/user/layout/LoadingComponent.vue";
import NotificationComponent from '@/components/custom/notifications/NotificationComponent.vue';
import { sendVerificationEmail } from "@/api/user.api";

export default {
  name: "EmailVerify",
  components: {
    Loading,
		NotificationComponent
  },
  data() {
    return {
			notification: {
				show: false,
				key: 0,	
				type:'',
				title: '',
				message: '',
			},
      isLoading: false,
    };
  },
  methods: {
    async sendVerifyLink() {
      this.isLoading = true;
      try {
        const response = await sendVerificationEmail();
        if (response.status) {
          this.isLoading = false;
					this.showNotification("success", this.$t("Custom.success"), response.data.msg);
        } else {
					this.showNotification("error", this.$t("Custom.error"), response.data.msg);
        }
      } catch (error) {
				this.showNotification("error", this.$t("Custom.error"), response.data.msg);
      } finally {
        this.isLoading = false;
      }
    },
		showNotification(type, title, message) {
      this.notification = {
        show: true,
				key: Date.now(),
        type,
        title,
        message,
      };
    },
  },
};
</script>

<style scoped>
.verify-container {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
	background: linear-gradient(135deg, #fff9f7 0%, #f1eeef 100%);
  padding: 20px;
}

.verify-content {
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.brand-section {
  text-align: center;
  margin-bottom: 2rem;
}

.logo-container {
  margin-bottom: 1rem;
}

.app-logo {
  width: 100px;
  height: 100px;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.app-name {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0.5rem 0;
	background: linear-gradient(135deg, #f0744e 0%, #f0386c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.tagline {
  font-size: 1.1rem;
  color: #666;
  margin: 0;
}

.verification-card {
  background: white;
  border-radius: 24px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 500px;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.verification-card:hover {
  transform: translateY(-5px);
}

.card-content {
  padding: 2.5rem;
  text-align: center;
}

.icon-container {
	background: #ffefea;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
}

.email-icon {
  color: var(--logo-color);
}

.verify-title {
  font-size: 1.5rem;
  color: #1a1a1a;
  margin-bottom: 1rem;
  font-weight: 600;
}

.verify-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.verify-button {
	background: linear-gradient(135deg, #f0744e 0%, #f04068 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
}

.verify-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(52, 152, 219, 0.2);
}

.button-icon {
  transition: transform 0.3s ease;
}

.verify-button:hover .button-icon {
  transform: translateX(4px);
}

@media (max-width: 768px) {
  .verify-content {
    padding: 1rem;
  }

  .app-name {
    font-size: 2rem;
  }

  .verification-card {
    margin: 0 1rem;
  }

  .card-content {
    padding: 2rem;
  }
}
</style>
